import { render, staticRenderFns } from "./ProcessInspection.vue?vue&type=template&id=b12ead7a&scoped=true"
import script from "./ProcessInspection.vue?vue&type=script&lang=js"
export * from "./ProcessInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12ead7a",
  null
  
)

export default component.exports